








import type { PropType } from '@nuxtjs/composition-api';
import { defineComponent } from '@nuxtjs/composition-api';

import AddToCartNotification from '@/diptyqueTheme/components/AddToCartNotification.vue';
import InfoNotification from '@/diptyqueTheme/components/InfoNotification.vue';
import { useUiNotification } from '~/composables';
import type { UiNotificationArea } from '~/composables/useUiNotification';

export default defineComponent({
  name: 'NotificationBar',
  components: {
    AddToCartNotification,
    InfoNotification
  },
  props: {
    area: {
      required: false,
      type: String as PropType<UiNotificationArea>,
      default: 'default'
    }
  },
  setup() {
    const { notifications, notificationsByArea } = useUiNotification();

    return {
      notifications,
      notificationsByArea
    };
  }
});
